globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.SelectFollower = (function () {
  function bind($scope, key, mapping, options) {
    options = options || {};
    var $source = $scope.find('[data-select-follower-source="' + key + '"]');
    var $target = $scope.find('[data-select-follower-target="' + key + '"]');
    if (!$source.length || !$target.length) {
      return;
    }
    var apply = function () {
      var sourceValue = String($source.val() || "");
      var mappedValue = mapping[sourceValue];
      if (mappedValue === undefined || mappedValue === null) {
        return;
      }
      if (options.onlyIfTargetEmpty && String($target.val() || "").length > 0) {
        return;
      }
      $target.val(mappedValue).trigger("change");
    };
    $source.on("change.selectFollower", apply);
  }

  return { bind: bind };
})();
